import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressLightbox',
  props: {
  imgs: {
    type: Array as PropType<Array<string>>,
    required: true,
  },
  isOpen: {
    type: Boolean,
    required: true,
  },
  index: {
    type: Number,
    required: false,
  },
},
  emits: {
  hide: () => true,
},
  setup(__props, { emit }) {





const onHide = () => {
  emit("hide");
};

return (_ctx: any,_cache: any) => {
  const _component_vue_easy_lightbox = _resolveComponent("vue-easy-lightbox")!

  return (_openBlock(), _createBlock(_component_vue_easy_lightbox, {
    visible: __props.isOpen,
    imgs: __props.imgs,
    onHide: onHide,
    index: __props.index
  }, null, 8, ["visible", "imgs", "index"]))
}
}

})